var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 21H12V27C13.6569 27 15 28.3431 15 30C15 31.6569 13.6569 33 12 33V45H60V33C58.3432 33 57 31.6569 57 30C57 28.3431 58.3432 27 60 27V21Z",
    stroke: "#A80A01",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 27,
    width: 6,
    height: 12,
    stroke: "#A80A01",
    strokeWidth: 2.25,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 27,
    width: 6,
    height: 12,
    stroke: "#A80A01",
    strokeWidth: 2.25,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 27,
    width: 6,
    height: 12,
    stroke: "#A80A01",
    strokeWidth: 2.25,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 45,
    width: 6,
    height: 4.5,
    stroke: "#A80A01",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 45,
    width: 6,
    height: 4.5,
    stroke: "#A80A01",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33,
    y: 45,
    width: 6,
    height: 4.5,
    stroke: "#A80A01",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 45,
    width: 6,
    height: 4.5,
    stroke: "#A80A01",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 45,
    width: 6,
    height: 4.5,
    stroke: "#A80A01",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRam);
export default __webpack_public_path__ + "static/media/RAM.4a6478c1f0b44ac1418a39b38c3f3fa9.svg";
export { ForwardRef as ReactComponent };